window.dlmenu = require('../Contrib/dlmenu/jquery.dlmenu');

require('./Helpers/UnhideOnlyJsVisibleItems');

$(document).ready(function() {

  require('./Helpers/MainNav');
  require('./Helpers/TileSlider');
  require('./Helpers/Tabs');
  require('./Helpers/SocialShare');
  require('./Helpers/TopOffCanvasSearch');
  require('./Helpers/MobileMenu');
  require('./Helpers/additional');
});
